import SessionStorageKeys from '../constants/sessionStorageKeys';

export default function storeUTMCampaign(campaignId: string) {
  sessionStorage.setItem(SessionStorageKeys.utmCampaign, JSON.stringify(campaignId));
}
